module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Trip Details")]), _vm._v(" "), (_vm.trip.status == 'ongoing') ? _c('div', [_c('span', {
    staticClass: "label label-success mr-5",
    staticStyle: {
      "float": "right",
      "font-size": "134%",
      "font-weight": "500",
      "height": "28px",
      "width": "139px",
      "margin-right": "20px",
      "margin-top": "-20px"
    }
  }, [_vm._v("Ongoing Trips")])]) : (_vm.trip.status == 'completed') ? _c('div', [_c('span', {
    staticClass: "label label-primary mr-5",
    staticStyle: {
      "float": "right",
      "font-size": "134%",
      "font-weight": "500",
      "height": "28px",
      "width": "156px",
      "margin-top": "-20px"
    }
  }, [_vm._v("Completed Trips")])]) : (_vm.trip.status == 'halt') ? _c('div', [_c('span', {
    staticClass: "label label-danger mr-5",
    staticStyle: {
      "float": "right",
      "font-size": "134%",
      "font-weight": "500",
      "height": "28px",
      "width": "139px",
      "margin-top": "-20px"
    }
  }, [_vm._v("Halt Trips")])]) : (_vm.trip.status == 'scheduled') ? _c('div', [_c('span', {
    staticClass: "label label-warning mr-5",
    staticStyle: {
      "float": "right",
      "font-size": "134%",
      "font-weight": "500",
      "height": "28px",
      "width": "153px",
      "margin-top": "-20px"
    }
  }, [_vm._v("Scheduled Trips")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), (_vm.trip.status == 'ongoing') ? _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('span', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.tripEnd('cancel')
      }
    }
  }, [_vm._v("Cancel Trip")]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-default",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#exampleModal"
    },
    on: {
      "click": function($event) {
        _vm.EditTrip()
      }
    }
  }, [_vm._v("Update Trip")]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.tripEnd('end')
      }
    }
  }, [_vm._v("End Trip")])]) : _vm._e(), _vm._v(" "), (_vm.trip.status == 'completed') ? _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('span', {
    staticClass: "btn btn-default",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#exampleModal"
    },
    on: {
      "click": function($event) {
        _vm.EditTrip()
      }
    }
  }, [_vm._v("Update Trip")])]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("Trip Code : " + _vm._s(_vm.trip.tripCode))])])]), _vm._v(" "), _c('div', {
    staticClass: "row trip-detail-tbl"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('tr', [_c('th', [_vm._v("From - To :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.trip.startSiteSiteName) + " - " + _vm._s(_vm.trip.endSiteSiteName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Scheduled Time :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.trip.scheduleTime))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Vehicle Registration No :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.trip.vehicleIdRegNo))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Scheduled Date :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.scheduledDate))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Driver Name :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.trip.driverIdDriverName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Device ID :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.trip.deviceIdImei))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "font-size": "17px",
      "color": "#3c8dbc"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("At " + _vm._s(_vm.trip.startSiteSiteName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("HCV reached origin At (Waiting Started At) :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.originReached))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Trip Started At :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.startedDate))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticStyle: {
      "font-size": "17px",
      "color": "#3c8dbc"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("At " + _vm._s(_vm.trip.endSiteSiteName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("HCV reached Destination At (Idling Started At) :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.destinationReached))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Trip Completed At :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s((this.endedDate)))])])])])]), _vm._v(" "), (_vm.trip.status == 'ongoing' || _vm.trip.status == 'completed') ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container collapse",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "id": "odometer"
    }
  }, [_c('div', [_vm._m(2), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((this.odometer), function(o) {
    return _c('tr', [_c('td', _vm._l((o.image), function(imgs1) {
      return _c('div', [_c('a', {
        attrs: {
          "href": ("" + _vm.i_url + (o.tripID) + "/" + (o.tripType) + "/" + (o.imageType) + "/" + (o.captureType) + "/" + imgs1),
          "target": "_blank"
        }
      }, [_c('img', {
        staticStyle: {
          "height": "50px",
          "margin": "2px",
          "width": "50px"
        },
        attrs: {
          "src": ("" + _vm.i_url + (o.tripID) + "/" + (o.tripType) + "/" + (o.imageType) + "/" + (o.captureType) + "/" + imgs1),
          "alt": "Not Available"
        }
      })]), _vm._v(" "), _c('br')])
    })), _vm._v(" "), _c('td', [_vm._v(_vm._s(o.tripType == 'startTrip' ? _vm.trip.startSiteSiteType : _vm.trip.endSiteSiteType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(o.latitude))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(o.longitude))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(o.meterReading))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(o.recordedTime))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "icons",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.openUpdateTripDia(o)
        }
      }
    }, [_c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ('edit details'),
        expression: "'edit details'"
      }],
      staticClass: "fa fa-edit",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v("\n                       \n                      "), _c('a', {
      staticClass: "icons",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteTripDetail(o)
        }
      }
    }, [_c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ('delete details'),
        expression: "'delete details'"
      }],
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [(this.odometer.length < 2) ? _c('button', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.openNewTripDia()
      }
    }
  }, [_vm._v("Add Odometer Details")]) : _vm._e()])]), _vm._v(" "), (this.startOdoMeterReading.length > 0 && this.endOdoMeterReading.length > 0 && this.endOdoMeterReading[this.endOdoMeterReading.length - 1].meterReading && this.startOdoMeterReading[this.startOdoMeterReading.length - 1].meterReading) ? _c('div', [_c('h5', [_c('b', [_vm._v("Distance Travel from " + _vm._s(_vm.trip.startSiteSiteType) + " to " + _vm._s(_vm.trip.endSiteSiteType) + " is " + _vm._s((this.endOdoMeterReading[this.endOdoMeterReading.length - 1].meterReading - this.startOdoMeterReading[this.startOdoMeterReading.length - 1].meterReading).toFixed(2)) + " km")])])]) : _vm._e(), _vm._v(" "), (this.startOdoMeterReading.length > 0 && this.endOdoMeterReading.length == 0) ? _c('div', [_c('h5', [_c('b', [_vm._v("Distance Travel from " + _vm._s(_vm.trip.startSiteSiteType) + " to " + _vm._s(_vm.trip.endSiteSiteType) + " is 0 km")])])]) : _vm._e(), _vm._v(" "), (this.startOdoMeterReading.length == 0 && this.endOdoMeterReading.length > 0 && this.endOdoMeterReading[this.endOdoMeterReading.length - 1].meterReading) ? _c('div', [_c('h5', [_c('b', [_vm._v("Distance Travel from " + _vm._s(_vm.trip.startSiteSiteType) + " to " + _vm._s(_vm.trip.endSiteSiteType) + " is " + _vm._s((this.endOdoMeterReading[this.endOdoMeterReading.length - 1].meterReading - 0).toFixed(2)) + " km")])])]) : _vm._e(), _vm._v(" "), (this.startOdoMeterReading.length == 0 && this.endOdoMeterReading.length == 0) ? _c('div', [_c('h5', [_c('b', [_vm._v("Distance Travel from " + _vm._s(_vm.trip.startSiteSiteType) + " to " + _vm._s(_vm.trip.endSiteSiteType) + " is 0 km")])])]) : _vm._e(), _vm._v(" "), (this.startRecordedTime.length > 0 && this.endRecordedTime.length > 0) ? _c('div', [_c('h5', [_c('b', [_vm._v("Travel time from " + _vm._s(_vm.trip.startSiteSiteType) + " to " + _vm._s(_vm.trip.endSiteSiteType) + " is " + _vm._s(this.timeDifference) + " sec")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "container collapse",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "id": "gasfilling"
    }
  }, [_c('div', [_vm._m(4), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((this.reportData), function(gs) {
    return _c('tr', [_c('td', [(gs.reading_1 == 'startTrip' && gs.reading_2 == 'post') ? _c('div', [_c('a', {
      attrs: {
        "href": (_vm.challan_img_url + "/" + _vm.urlId + "/startTrip/challan/pre/" + _vm.challanImage),
        "target": "_blank"
      }
    }, [_c('img', {
      staticStyle: {
        "height": "50px",
        "margin": "2px",
        "width": "50px"
      },
      attrs: {
        "src": (_vm.challan_img_url + "/" + _vm.urlId + "/startTrip/challan/pre/" + _vm.challanImage),
        "alt": "Not Available"
      }
    })])]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(gs.reading_1 == "startTrip" ? _vm.trip.startSiteSiteType : _vm.trip.endSiteSiteType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(gs.reading_2 == "pre" ? 'Initial' : 'Final'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(gs.reading_3 ? gs.reading_3 : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(gs.reading_4 ? gs.reading_4 : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(gs.reading_5 ? gs.reading_5 : ''))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('a', {
      staticClass: "icons",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.openUpdateGasFlowDia(gs)
        }
      }
    }, [_c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ('edit details'),
        expression: "'edit details'"
      }],
      staticClass: "fa fa-edit",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v("  \n                      "), _c('a', {
      staticClass: "icons",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteopenUpdateGasFlowDia(gs)
        }
      }
    }, [_c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ('delete details'),
        expression: "'delete details'"
      }],
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [(this.reportData.length < 4) ? _c('button', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.openNewGasFlowDia()
      }
    }
  }, [_vm._v("Add Gas Flow Meter Details")]) : _vm._e()])]), _vm._v(" "), (this.postStartGas.length > 0 && this.preStartGas.length > 0 && this.postStartGas[this.postStartGas.length - 1].meterReading && this.preStartGas[this.preStartGas.length - 1].meterReading) ? _c('div', [_c('h5', [_c('b', [_vm._v("Gas Flow Meter Difference at " + _vm._s(_vm.trip.startSiteSiteType) + " is " + _vm._s((this.postStartGas[this.postStartGas.length - 1].meterReading - this.preStartGas[this.preStartGas.length - 1].meterReading).toFixed(2)))])])]) : _vm._e(), _vm._v(" "), (this.postStartGas.length > 0 && this.preStartGas.length == 0 && this.postStartGas[this.postStartGas.length - 1].meterReading) ? _c('div', [_c('h5', [_c('b', [_vm._v("Gas Flow Meter Difference at " + _vm._s(_vm.trip.startSiteSiteType) + " is " + _vm._s((this.postStartGas[this.postStartGas.length - 1].meterReading - 0).toFixed(2)))])])]) : _vm._e(), _vm._v(" "), (this.preStartGas.length > 0 && this.postStartGas.length == 0 && this.preStartGas[this.postStartGas.length - 1].meterReading) ? _c('div', [_c('h5', [_c('b', [_vm._v("Gas Flow Meter Difference at " + _vm._s(_vm.trip.startSiteSiteType) + " is " + _vm._s((0 - this.preStartGas[this.postStartGas.length - 1].meterReading).toFixed(2)))])])]) : _vm._e(), _vm._v(" "), (this.postEndGas.length > 0 && this.preEndGas.length > 0 && this.postEndGas[this.postEndGas.length - 1].meterReading && this.preEndGas[this.preEndGas.length - 1].meterReading) ? _c('div', [_c('h5', [_c('b', [_vm._v("Gas Flow Meter Difference at " + _vm._s(_vm.trip.endSiteSiteType) + " is " + _vm._s((this.postEndGas[this.postEndGas.length - 1].meterReading - this.preEndGas[this.preEndGas.length - 1].meterReading).toFixed(2)))])])]) : _vm._e(), _vm._v(" "), (this.postEndGas.length > 0 && this.preEndGas.length == 0 && this.postEndGas[this.postEndGas.length - 1].meterReading) ? _c('div', [_c('h5', [_c('b', [_vm._v("Gas Flow Meter Difference at " + _vm._s(_vm.trip.endSiteSiteType) + " is " + _vm._s((this.postEndGas[this.postEndGas.length - 1].meterReading).toFixed(2)))])])]) : _vm._e(), _vm._v(" "), (this.postEndGas.length == 0 && this.preEndGas.length > 0 && this.preEndGas[this.preEndGas.length - 1].meterReading) ? _c('div', [_c('h5', [_c('b', [_vm._v("Gas Flow Meter Difference at " + _vm._s(_vm.trip.endSiteSiteType) + " is " + _vm._s((0 - this.preEndGas[this.preEndGas.length - 1].meterReading).toFixed(2)))])])]) : _vm._e()])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.trip.status == 'ongoing' || _vm.trip.status == 'completed') ? _c('div', {
    staticClass: "tab"
  }, [_c('button', {
    staticClass: "tablinks btn",
    staticStyle: {
      "color": "white"
    },
    on: {
      "click": _vm.exceptionTable
    }
  }, [_vm._v("Show Exceptions")]), _vm._v(" "), _c('button', {
    staticClass: "tablinks btn",
    staticStyle: {
      "color": "white"
    },
    on: {
      "click": _vm.locationLogTable
    }
  }, [_vm._v("Trip Details")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Trip'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])])], 1) : _vm._e(), _vm._v(" "), (_vm.trip.status == 'scheduled' || _vm.trip.status == 'halt') ? _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'TripDetail'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tabcontent",
    staticStyle: {
      "display": "none",
      "margin-top": "10px"
    },
    attrs: {
      "id": "exceptionTable"
    }
  }, [_c('div', [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    class: _vm.addButtonClass
  }), _vm._v(" "), _c('div', [_c('v-server-table', {
    ref: "tripExceptionTable",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "loaded": _vm.onLoaded
    }
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])]), _vm._v(" "), _c('div', [_c('TripLocationLog', {
    staticClass: "tabcontent",
    staticStyle: {
      "display": "none",
      "margin-top": "10px"
    },
    attrs: {
      "id": "tripLocationLogTable"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "exampleModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("HCV reached origin At (Waiting Started At) :")]), _vm._v(" "), _c('td', [_c('datetime', {
    attrs: {
      "type": "datetime",
      "use12-hour": ""
    },
    model: {
      value: (_vm.trip.originReachedAt),
      callback: function($$v) {
        _vm.$set(_vm.trip, "originReachedAt", $$v)
      },
      expression: "trip.originReachedAt"
    }
  })], 1)]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("Trip Started At :")]), _vm._v(" "), _c('td', [_c('datetime', {
    attrs: {
      "type": "datetime",
      "use12-hour": ""
    },
    model: {
      value: (_vm.trip.startDate),
      callback: function($$v) {
        _vm.$set(_vm.trip, "startDate", $$v)
      },
      expression: "trip.startDate"
    }
  })], 1)]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("HCV reached Destination At (Idling Started At) :")]), _vm._v(" "), _c('td', [_c('datetime', {
    attrs: {
      "type": "datetime",
      "use12-hour": ""
    },
    model: {
      value: (_vm.trip.destinationReachedAt),
      callback: function($$v) {
        _vm.$set(_vm.trip, "destinationReachedAt", $$v)
      },
      expression: "trip.destinationReachedAt"
    }
  })], 1)]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("Trip Completed At :")]), _vm._v(" "), _c('td', [_c('datetime', {
    attrs: {
      "type": "datetime",
      "use12-hour": ""
    },
    model: {
      value: (_vm.trip.endDate),
      callback: function($$v) {
        _vm.$set(_vm.trip, "endDate", $$v)
      },
      expression: "trip.endDate"
    }
  })], 1)]), _vm._v(" "), (_vm.trip.status == 'ongoing') ? _c('tr', [_c('th', [_vm._v("Change Trip Status")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusValue),
      expression: "statusValue"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.statusValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeStatus]
    }
  }, [_c('option', {
    attrs: {
      "value": "completed"
    }
  }, [_vm._v("Completed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cancelled"
    }
  }, [_vm._v("Cancelled")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.tripEnd('update')
      }
    }
  }, [_vm._v("Save")])])])])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "tripDialog",
      "height": "425"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "modal-basic-title"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.edit.title))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.$modal.hide('tripDialog');
        _vm.refreshTab();
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Trip Type:")])]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.tripType),
      expression: "edit.tripType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.edit, "tripType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "startTrip"
    }
  }, [_vm._v("Origin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "endTrip"
    }
  }, [_vm._v("Destination")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Latitude:")])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.latitude),
      expression: "edit.latitude"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.edit.latitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.edit, "latitude", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Longitude:")])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.longitude),
      expression: "edit.longitude"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.edit.longitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.edit, "longitude", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Meter Reading:")])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.meterReading),
      expression: "edit.meterReading"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.edit.meterReading)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.edit, "meterReading", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Recorded Time:")])]), _vm._v(" "), _c('td', [_c('datetime', {
    attrs: {
      "type": "datetime",
      "use12-hour": ""
    },
    model: {
      value: (_vm.edit.recordedTime),
      callback: function($$v) {
        _vm.$set(_vm.edit, "recordedTime", $$v)
      },
      expression: "edit.recordedTime"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [(_vm.edit.title == 'Create trip') ? _c('div', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Image:")])]), _vm._v(" "), _c('td', [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "name": "image"
    },
    on: {
      "change": _vm.onFilechanged
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "image"
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.edit.title == 'Create trip') ? _c('button', {
    staticClass: "tablinks btn",
    staticStyle: {
      "color": "white"
    },
    on: {
      "click": function($event) {
        _vm.createTrip()
      }
    }
  }, [_vm._v("Create")]) : _vm._e(), _vm._v(" "), (_vm.edit.title == 'Update trip') ? _c('button', {
    staticClass: "tablinks btn",
    staticStyle: {
      "color": "white"
    },
    on: {
      "click": function($event) {
        _vm.updateTrip()
      }
    }
  }, [_vm._v("Update")]) : _vm._e()])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "gasFlowDia",
      "height": "425"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "modal-basic-title"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.editGasFlow.title))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.$modal.hide('gasFlowDia');
        _vm.refreshTab();
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Trip Type:")])]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGasFlow.reading_1),
      expression: "editGasFlow.reading_1"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editGasFlow, "reading_1", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "startTrip"
    }
  }, [_vm._v("MS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "endTrip"
    }
  }, [_vm._v("DBS")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Capture Type:")])]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGasFlow.reading_2),
      expression: "editGasFlow.reading_2"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editGasFlow, "reading_2", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "pre"
    }
  }, [_vm._v("Initial")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "post"
    }
  }, [_vm._v("Final")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Pressure Gauge Reading:")])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGasFlow.reading_3),
      expression: "editGasFlow.reading_3"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.editGasFlow.reading_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editGasFlow, "reading_3", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Gas Flow Meter Reading:")])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGasFlow.reading_4),
      expression: "editGasFlow.reading_4"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.editGasFlow.reading_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editGasFlow, "reading_4", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Recorded Time:")])]), _vm._v(" "), _c('td', [_c('datetime', {
    attrs: {
      "type": "datetime",
      "use12-hour": ""
    },
    model: {
      value: (_vm.editGasFlow.reading_5),
      callback: function($$v) {
        _vm.$set(_vm.editGasFlow, "reading_5", $$v)
      },
      expression: "editGasFlow.reading_5"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [(_vm.editGasFlow.title == 'Add Gas Flow Details' && _vm.editGasFlow.reading_1 === 'startTrip' && _vm.editGasFlow.reading_2 === 'post') ? _c('div', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Upload Challan:")])]), _vm._v(" "), _c('td', [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "name": "Upload Challan"
    },
    on: {
      "change": _vm.onFilechanged1
    }
  })]), _vm._v(" "), _c('td', [_c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "Upload Challan"
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.editGasFlow.title == 'Add Gas Flow Details') ? _c('button', {
    staticClass: "tablinks btn",
    staticStyle: {
      "color": "white"
    },
    on: {
      "click": function($event) {
        _vm.createGasFlowDetails()
      }
    }
  }, [_vm._v("Create")]) : _vm._e(), _vm._v(" "), (_vm.editGasFlow.title == 'Update Gas Flow Details') ? _c('button', {
    staticClass: "tablinks btn",
    staticStyle: {
      "color": "white"
    },
    on: {
      "click": function($event) {
        _vm.updateGasFlowDetails()
      }
    }
  }, [_vm._v("Update")]) : _vm._e()])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "btn dropdown-toggle",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "data-toggle": "collapse",
      "href": "#odometer",
      "role": "button",
      "aria-expanded": "false",
      "aria-controls": "odometer"
    }
  }, [_vm._v("Odometer Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "btn dropdown-toggle",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "data-toggle": "collapse",
      "href": "#gasfilling",
      "role": "button",
      "aria-expanded": "false",
      "aria-controls": "gasfilling"
    }
  }, [_vm._v("Gas Flow Meter Detail")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v("Odometer Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Image")]), _vm._v(" "), _c('th', [_vm._v("Trip Type")]), _vm._v(" "), _c('th', [_vm._v("Latitude")]), _vm._v(" "), _c('th', [_vm._v("Longitude")]), _vm._v(" "), _c('th', [_vm._v("Meter Reading")]), _vm._v(" "), _c('th', [_vm._v("RecordedTime")]), _vm._v(" "), _c('th', [_vm._v("Edit")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v("Gas Flow Meter Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Challan Image")]), _vm._v(" "), _c('th', [_vm._v("Trip Type")]), _vm._v(" "), _c('th', [_vm._v("Capture Type")]), _vm._v(" "), _c('th', [_vm._v("Pressure Gauge Reading")]), _vm._v(" "), _c('th', [_vm._v("Gas Flow Meter Reading")]), _vm._v(" "), _c('th', [_vm._v("RecordedTime")]), _vm._v(" "), _c('th', [_vm._v("Edit")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Trip Exception")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1bb63ccf", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bb63ccf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/trip/TripActivity.vue
// module id = 2269
// module chunks = 0